import { AfterViewInit, Directive, ElementRef, HostListener, OnDestroy, Renderer2, inject } from '@angular/core';

@Directive({
  selector: 'textarea[maxlength]',
  standalone: false,
})
export class CharCounterDirective implements AfterViewInit, OnDestroy {
  private readonly el = inject(ElementRef<HTMLTextAreaElement>);
  private readonly renderer = inject(Renderer2);

  private counterEl: HTMLElement;
  private wrapperEl: HTMLElement;
  private focused = false;

  ngAfterViewInit(): void {
    const textarea = this.el.nativeElement as HTMLTextAreaElement;
    const parent = textarea.parentElement;

    this.wrapperEl = this.renderer.createElement('div') as HTMLElement;
    this.renderer.addClass(this.wrapperEl, 'char-counter-wrapper');
    this.renderer.insertBefore(parent, this.wrapperEl, textarea);
    this.renderer.appendChild(this.wrapperEl, textarea);

    this.counterEl = this.renderer.createElement('div') as HTMLElement;
    this.renderer.addClass(this.counterEl, 'char-counter');
    this.renderer.setStyle(this.counterEl, 'display', 'none');
    this.renderer.appendChild(this.wrapperEl, this.counterEl);

    this.update();
  }

  ngOnDestroy(): void {
    const textarea = this.el.nativeElement as HTMLTextAreaElement;
    const parent = this.wrapperEl?.parentElement;
    if (parent) {
      this.renderer.insertBefore(parent, textarea, this.wrapperEl);
      this.renderer.removeChild(parent, this.wrapperEl);
    }
  }

  @HostListener('focus')
  onFocus(): void {
    this.focused = true;
    this.update();
  }

  @HostListener('blur')
  onBlur(): void {
    this.focused = false;
    this.update();
  }

  @HostListener('input')
  onInput(): void {
    this.update();
  }

  private update(): void {
    if (!this.counterEl) return;

    const textarea = this.el.nativeElement as HTMLTextAreaElement;
    const maxLength = parseInt(textarea.getAttribute('maxlength'), 10);
    if (isNaN(maxLength)) return;

    const current = (textarea.value ?? '').length;
    const nearLimit = current / maxLength >= 0.8;
    const visible = this.focused || nearLimit;

    this.renderer.setStyle(this.counterEl, 'display', visible ? '' : 'none');
    if (visible) {
      this.counterEl.textContent = `${current}/${maxLength}`;
    }
  }
}
